import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group';
import gibletLogo from '@/assets/giblet-logo.png';

export default function DemoCallForKnowledgeConnection() {
  const navigate = useNavigate();
  const location = useLocation();
  const [connectedToCfS, setConnectedToCfS] = useState<string>('');

  const handleNext = () => {
    const isConnected = connectedToCfS === 'yes';
    navigate('/demo-call-for-knowledge/bounty', {
      state: { 
        ...location.state,
        connectedToCfS: isConnected
      }
    });
  };

  return (
    <div className="min-h-screen bg-background flex flex-col items-center justify-center p-6">
      <div className="max-w-2xl w-full space-y-8">
        <div className="flex justify-center mb-8">
          <img src={gibletLogo} alt="Giblet Logo" className="h-16 w-auto" />
        </div>

        <div className="text-center space-y-4">
          <h1 className="text-3xl font-bold text-foreground">CfS Connection</h1>
          <p className="text-lg text-muted-foreground">
            Is this Call for Knowledge connected to an existing Call for Solution?
          </p>
        </div>

        <div className="bg-card rounded-lg p-8 shadow-lg space-y-6">
          <div className="space-y-4">
            <p className="text-muted-foreground">
              Knowledge contributions can be standalone or support specific solution development efforts.
              If this CfK is supporting a Call for Solution, select "Yes" below.
            </p>
            
            <RadioGroup value={connectedToCfS} onValueChange={setConnectedToCfS}>
              <div className="flex items-center space-x-3 p-4 rounded-lg hover:bg-accent/50 transition-colors">
                <RadioGroupItem value="yes" id="yes" />
                <Label htmlFor="yes" className="flex-1 cursor-pointer">
                  <div className="font-semibold text-foreground">Yes, connected to a CfS</div>
                  <div className="text-sm text-muted-foreground mt-1">
                    This knowledge will support a specific Call for Solution
                  </div>
                </Label>
              </div>
              
              <div className="flex items-center space-x-3 p-4 rounded-lg hover:bg-accent/50 transition-colors">
                <RadioGroupItem value="no" id="no" />
                <Label htmlFor="no" className="flex-1 cursor-pointer">
                  <div className="font-semibold text-foreground">No, standalone CfK</div>
                  <div className="text-sm text-muted-foreground mt-1">
                    This is an independent knowledge gathering effort
                  </div>
                </Label>
              </div>
            </RadioGroup>
          </div>
        </div>

        <div className="flex justify-center gap-4">
          <Button
            variant="outline"
            onClick={() => navigate('/demo-call-for-knowledge/functional-area')}
            className="min-w-[120px]"
          >
            Back
          </Button>
          <Button
            onClick={handleNext}
            disabled={!connectedToCfS}
            className="min-w-[120px]"
          >
            Next
          </Button>
        </div>
      </div>
    </div>
  );
}
